import { IconButton, Stack, Typography } from '@mui/joy';
import { X } from '@phosphor-icons/react';
import { SyntheticEvent, useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { Button, NumberInput } from 'core/components';
import { Direction, Level, Size, Variant } from 'theme/enums';

import { useTimeLogIntervalContext } from './useTimeLogInterval';

export const IntervalControls = () => {
  const { t } = useTranslation();

  const { intervalHours, onIntervalHoursChange, onSetIntervalTime, onCancelInterval } =
    useTimeLogIntervalContext();

  const handleIntervalHoursChange = useCallback(
    (e: {
      target: { name: string; value: string };
      source: 'prop' | 'event';
      event?: SyntheticEvent;
    }) => {
      onIntervalHoursChange(e.target.value ? Number(e.target.value) : null);
    },
    [onIntervalHoursChange]
  );

  return (
    <Stack
      direction={Direction.ROW}
      sx={{
        alignItems: 'center',
        gap: 2,
        justifyContent: 'space-between',
      }}
    >
      <Stack direction={Direction.ROW} sx={{ alignItems: 'center', gap: 2 }}>
        <Typography level={Level.BODY_MD} sx={{ fontWeight: 500 }}>
          {t('labelSetEqualTimeForAllDays')}:
        </Typography>

        <NumberInput
          name="intervalHours"
          size={Size.SM}
          value={intervalHours}
          onChange={handleIntervalHoursChange}
          placeholder={` ${t('labelHrs')}`}
          slotProps={{
            input: {
              decimalScale: 2,
              max: 24,
              min: 0,
              suffix: ` ${t('labelHrs')}`,
              thousandSeparator: true,
            },
          }}
          sx={{ width: '90px', '--Input-minHeight': '28px' }}
          autoFocus
        />

        <Button
          onClick={onSetIntervalTime}
          disabled={intervalHours === null}
          text={t('buttonLabelSetTime')}
        />
      </Stack>

      <IconButton variant={Variant.PLAIN} onClick={onCancelInterval}>
        <X weight="bold" />
      </IconButton>
    </Stack>
  );
};
